class help {

    constructor() {
        this.set_listeners();
    }


    set_listeners() {
        var self = this;
        $(".configurator i").click(function () {
            self.show($(this).data('id'))
        })
    }

    show(id) {
        if (typeof (texts.help[id]) === 'undefined') {
            return;
        }

        var help_item = texts.help[id];
        var html = '<div class="help_div" style="height: 500px; max-width: 500px;">';
        html += "<h1>" + help_item.title + "</h1>";
        html += "<div>" + help_item.text + "</div>";
        if (help_item.picture) {
            html += "<img src='" + help_item.picture + "'>";
        }
        html += "</div>";

        jQuery.colorbox({html: html});
    }

}